import React, { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import api from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { Seo } from "@/components/Seo";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { clear } = useCart();
  const [status, setStatus] = useState("checking");
  const attempts = useRef(0);
  const cleared = useRef(false);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let timer;
    const poll = async () => {
      if (attempts.current >= 8) { setStatus("timeout"); return; }
      attempts.current += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          if (!cleared.current) { clear(); cleared.current = true; }
          return;
        }
        if (data.status === "expired" || data.payment_status === "failed") { setStatus("error"); return; }
      } catch { /* retry */ }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId, clear]);

  return (
    <div className="flex min-h-[70vh] items-center justify-center px-5" data-testid="payment-success-page">
      <Seo title="Order Confirmed — The Hoodie Project®" />
      <div className="w-full max-w-md border border-border p-10 text-center">
        {status === "checking" && (<><Loader2 className="mx-auto h-12 w-12 animate-spin" /><h1 className="mt-6 font-display text-2xl font-bold">CONFIRMING PAYMENT…</h1><p className="mt-2 text-sm text-muted-foreground">Hang tight, don't close this page.</p></>)}
        {status === "paid" && (<><CheckCircle2 className="mx-auto h-12 w-12" /><h1 className="mt-6 font-display text-3xl font-extrabold tracking-tighter" data-testid="success-message">ORDER CONFIRMED</h1><p className="mt-3 text-sm text-muted-foreground">Your hoodie is on its way. Check your email for the receipt and tracking updates.</p><Link to="/shop" className="mt-8 inline-block bg-white px-8 py-4 text-xs font-bold tracking-[0.2em] text-black hover:bg-neutral-300">KEEP SHOPPING</Link></>)}
        {(status === "error" || status === "timeout") && (<><XCircle className="mx-auto h-12 w-12" /><h1 className="mt-6 font-display text-2xl font-bold">SOMETHING WENT OFF</h1><p className="mt-2 text-sm text-muted-foreground">We couldn't confirm your payment yet. If you were charged, it'll appear in your email shortly.</p><Link to="/cart" className="mt-8 inline-block border border-border px-8 py-4 text-xs font-bold tracking-[0.2em] hover:bg-white hover:text-black">BACK TO BAG</Link></>)}
      </div>
    </div>
  );
}
